export default __webpack_public_path__ + "static/media/step3.d77e124d.png";